<template>
  <div>
    <div class="form-group">
      <!--        <label v-if="label" :for="name">{{label}}</label>-->
      <label v-if="label" :for="name">{{ label }}</label
      ><span class="text-danger" v-if="required"> *</span>
      <flat-pickr
        class="form-control"
        :id="name"
        :name="name"
        v-model="vModel"
        :placeholder="placeholder"
        :disabled="!!disabled"
        :config="config"
        @on-change="onChange"
      />
      <span class="date-icon">
        <i class="far fa-calendar-alt"></i>
      </span>
    </div>
    <small
      class="form-text text-danger"
      v-if="errors && errors[error_name || name]"
      v-text="errors[error_name || name][0]"
    />
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { english } from "flatpickr/dist/l10n/default.js";
import { Arabic } from "flatpickr/dist/l10n/ar.js";

export default {
  props: {
    label: {
      type: String,
    },

    name: {
      type: String,
      required: true,
    },

    model: {
      type: [Object, Array],
      required: true,
    },

    errors: {
      type: [Object, Array],
      required: true,
    },
    error_name: {
      type: String,
    },
    disabled: {
      type: [Boolean, Number],
    },

    options: {
      type: Object,
    },
    required: {
      type: Boolean,
    },
  },

  components: {
    flatPickr,
  },

  computed: {
    placeholder() {
      return this.label
        ? `${this.Lang.get("messages.select")} ${this.label}`
        : "";
    },

    config() {
      return {
        ...this.options,
        locale: this.Lang.getLocale() == "en" ? english : Arabic,
      };
    },
    vModel: {
      get: function () {
        return _.get(this.model, this.name);
      },
      // setter
      set: function (newValue) {
        // _.set(this.model, this.name, newValue);
        // console.log(this.name);
        if (this.name.includes(".")) {
          /* let base = this.name.substring(0, this.name.lastIndexOf('.'));
                        // base = 'content';
                        let name = this.name.substring(this.name.lastIndexOf('.') + 1, this.name.length);
                        // console.log(this.model[base]);
                        this.$set(this.model[`${base}`], name, newValue); */
          _.set(this.model, this.name, newValue);
        } else {
          this.$set(this.model, this.name, newValue);
        }
      },
    },
  },

  methods: {
    onChange(value) {
      this.$emit("change", value);
    },
  },
};
</script>

<style></style>
